import styled, { css } from 'styled-components';
import { Icon, Button } from 'src/components';

export const Layout = styled.div(
  ({ theme }) => css`
    max-width: ${theme.sz.xs};
    display: flex;
    flex-direction: column;
  `,
);

export const BuddyIcon = styled(Icon)(
  ({ theme }) => css`
    margin: auto;
    font-size: ${theme.sz.s48};
    transform: rotate(-8deg);
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s6};
    text-align: center;
    ${theme.typography.heading.desktop.s};
    color: ${theme.co.secondary20};
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s1};
    text-align: center;
    ${theme.typography.paragraph.m};
    color: ${theme.co.secondary20};
  `,
);

export const FinishButton = styled(Button)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s24};
  `,
);

export const PathButtonsWrapper = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s24};
  `,
);

export const RestartButton = styled(Button)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s6};
  `,
);
